import React from "react";
import outflow from "../../../../../assets/Images/finance/outflow.png";
import universal from "../../../../../assets/Images/finance/universal.png";
import { ReactComponent as BsArrowRight } from "../../../../../assets/Icons/Universal/BsArrowRight.svg";
import "../../../../../styles/Pages/Financial/CashInFlow/Dashboard/SheetLinks.styles.css";

const SheetLinks = ({ setShowOutFlowSheet }) => {
  return (
    <div className="SheetLinksContainer">
      <div onClick={() => setShowOutFlowSheet(true)} className="outflowSheet">
        <h3>
          Go to outflow sheet <BsArrowRight />
        </h3>
        <p>All the data of cash outflow you can track.</p>
        <div className="imageContainer">
          <div className="lines">
            <div style={{ backgroundColor: "#E4765C" }} className="line1"></div>
            <div style={{ backgroundColor: "#F6C8AC" }} className="line2"></div>
            <div style={{ backgroundColor: "#C77B6D" }} className="line3"></div>
          </div>
          <div className="image">
            <img src={outflow} alt="" />
          </div>
        </div>
      </div>
      <div className="universalSheet">
        <h3>
          Go to universal sheet <BsArrowRight />
        </h3>
        <p>All the data of cash inflow and cash outflow you can track.</p>
        <div className="imageContainer">
          <div className="lines">
            <div style={{ backgroundColor: "#E4765C" }} className="line1"></div>
            <div style={{ backgroundColor: "#F6C8AC" }} className="line2"></div>
            <div style={{ backgroundColor: "#C77B6D" }} className="line3"></div>
          </div>
          <div className="image">
            <img src={universal} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SheetLinks;
